/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import ModalUpload from "./modal-upload";
import { remove, length, includes } from "ramda";
import translate from "application/functions/application/translate";
import { handleFiles, handleUpdateFile } from "module/functions/handleFiles";
import ProgressBar from "./progress-bar";
import ErrorInput from "assets/img/error-input";
import InfoAlert from "./info-alert";
import DeleteImage from "assets/img/delete-image.png";

const MediaField = React.memo(({ path, register, setSelectValue, windowSize, isMobileBrowser, errors }) => {
  const [imagesUrl, setImagesUrl] = useState([]);
  const [sendToBackImagesUrl, setSendToBackImagesUrl] = useState([]);
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [indexSelectedImage, setIndexSelectedImage] = useState("");
  const [imgArr, setImgArr] = useState([]);

  const [showSpinner0, setShowSpinner0] = useState(false);
  const [showSpinner1, setShowSpinner1] = useState(false);
  const [showSpinner2, setShowSpinner2] = useState(false);

  const [progress0, setProgress0] = useState(0);
  const [progress1, setProgress1] = useState(0);
  const [progress2, setProgress2] = useState(0);

  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    setImagesUrl(sendToBackImagesUrl);
  }, [sendToBackImagesUrl]);

  useEffect(() => {
    for (let i = 0; i < 3; i++) {
      if (imgArr[i]) {
        setSelectValue(`${path}[${i}].arrangement_images.value`, imgArr[i]);
      } else {
        setSelectValue(`${path}[${i}].arrangement_images.value`, null);
      }
    }
  }, [imgArr]);

  const show = includes(`${path}[0].arrangement_images.value`, errors?.keys ?? []);

  const getImages = (e) => {
    const inputFiles = e.target;
    const files = inputFiles.files;

    if (files.length + imagesUrl.length > 3) {
      handleShowAlert();
      return;
    }
    const imagesLength = imagesUrl.length + files.length <= 3;

    if (imagesUrl.length <= 2 && imagesLength) {
      if (files.length > 3) {
        return;
      } else {
        setImagesUrl([...imagesUrl, ...files]);
        handleFiles(
          files,
          sendToBackImagesUrl,
          setSendToBackImagesUrl,
          imgArr,
          setImgArr,
          [setProgress0, setProgress1, setProgress2],
          [setShowSpinner0, setShowSpinner1, setShowSpinner2]
        );
      }
    }
  };

  const handleModalUpload = (item, index) => {
    if (imagesUrl.length !== sendToBackImagesUrl.length) {
      return;
    }
    setShowModalUpload(true);
    setSelectedImage(item);
    setIndexSelectedImage(index);
  };
  const handleCancel = () => {
    setShowModalUpload(false);
  };
  const handleDelete = (item, index) => {
    setShowModalUpload(false);
    const newImagesUrl = remove(index, 1, imagesUrl);
    const newImgArr = remove(index, 1, imgArr);
    setImagesUrl(newImagesUrl);
    setSendToBackImagesUrl(newImagesUrl);
    setImgArr(newImgArr);
    const inputElement = document.getElementById(`add-media-${path}`);
    if (inputElement) {
      inputElement.value = "";
    }
  };

  const handleUpdate = (index, e) => {
    setShowModalUpload(false);
    const inputFiles = e.target;
    const files = inputFiles.files;
    const imagesArray = [...imagesUrl];
    imagesArray[index] = files[0];
    setImagesUrl(imagesArray);
    handleUpdateFile(files[0], sendToBackImagesUrl, setSendToBackImagesUrl, imgArr, setImgArr, path, index);
  };

  const getProgress = (i) => {
    const progress = { 0: progress0, 1: progress1, 2: progress2 };
    return progress[i];
  };

  const getSpinner = (i) => {
    const spinner = { 0: showSpinner0, 1: showSpinner1, 2: showSpinner2 };
    return spinner[i];
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  const handleShowAlert = () => {
    setShowAlert(true);
  };

  return (
    <Fragment>
      {showAlert && <InfoAlert message={translate("limit.media")} onClose={handleAlertClose} />}
      <ModalUpload
        selectedImage={selectedImage}
        indexSelectedImage={indexSelectedImage}
        showModal={showModalUpload}
        onCancel={handleCancel}
        onDelete={handleDelete}
        onUpdate={handleUpdate}
      />
      <div className="form__add-multimedia-container">
        {imagesUrl &&
          imagesUrl.map((url, index) => {
            return (
              <Fragment key={index}>
                <div className="media-field__image-container">
                  <img
                    onClick={() => {
                      if (windowSize.innerWidth < 1024 && isMobileBrowser) {
                        handleModalUpload(url, index);
                      } else {
                        handleDelete(selectedImage, indexSelectedImage);
                      }
                    }}
                    className="media-field__image"
                    src={URL.createObjectURL(url)}
                    alt="img"
                    title="img"
                    // style={{ opacity: `${getProgress(index) < 100 ? "0.6" : "1"}` }}
                  />
                  {!isMobileBrowser && (
                    <div className="media-field__cross">
                      <img src={DeleteImage} alt="Delete" />
                    </div>
                  )}

                  <ProgressBar completed={getProgress(index)} />
                  {getSpinner(index) && <div className="loading"></div>}
                </div>
              </Fragment>
            );
          })}
      </div>
      {length(imagesUrl ?? []) < 3 && (
        <div className="form__add-multimedia-container">
          <label className="form__add-multimedia-button">
            <input
              type="file"
              ref={register}
              id={`add-media-${path}`}
              accept="image/png, image/jpeg, image/jpg, image/JPG"
              onChange={(e) => {
                getImages(e);
              }}
              multiple
              hidden
            />
            <p style={{ cursor: "pointer" }}>+ {translate(`add.media`)}</p>
          </label>

          {show && (
            <div className="form__show-warning">
              <ErrorInput /> <span>{translate(`error.image`)}</span>
            </div>
          )}
        </div>
      )}
      <p style={{ marginTop: "17px" }}>{translate("image.permisos")}</p>
      <input
        className={`field-creator__textfield`}
        type="text"
        name={`${path}[0].arrangement_images.value`}
        ref={register}
        style={{ display: "none" }}
      />
      <input
        className={`field-creator__textfield`}
        type="text"
        name={`${path}[1].arrangement_images.value`}
        ref={register}
        style={{ display: "none" }}
      />
      <input
        className={`field-creator__textfield`}
        type="text"
        name={`${path}[2].arrangement_images.value`}
        ref={register}
        style={{ display: "none" }}
      />
    </Fragment>
  );
});

export default MediaField;
